 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERIMAGE from '@/components/CoverImage'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC from '@/components/Wolterstorff_The_God_We_Worship_text_CC'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC1 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-1'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC2 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-2'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC3 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-3'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC5 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-5'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC6 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-6'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC7 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-7'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC8 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-8'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC9 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-9'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC10 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-10'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC11 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-11'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC12 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-12'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC13 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-13'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC14 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-14'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC15 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-15'
 import WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC16 from '@/components/Wolterstorff_The_God_We_Worship_text_CC-16'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC-1",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC-1",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC1
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC-2",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC-2",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC2
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC-3",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC-3",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC3
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC-5",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC-5",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC5
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC-6",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC-6",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC6
 		},
 		{
 			"path" : "/Wolterstorff_The_God_We_Worship_text_CC-7",
 			"name" : "Wolterstorff_The_God_We_Worship_text_CC-7",
 			"component" : WOLTERSTORFF_THE_GOD_WE_WORSHIP_TEXT_CC7
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js